"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageButton = void 0;
var React = __importStar(require("react"));
var HeaderLink_1 = require("./_shared/HeaderLink");
var useHeaderProps_1 = require("../hooks/useHeaderProps");
var Icon_1 = require("../../Icon");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var react_1 = require("@chakra-ui/react");
var ManageButton = function () {
    var _js = (0, useHeaderProps_1.useHeaderProps)()._js;
    return (React.createElement(react_1.Flex, null,
        React.createElement(HeaderLink_1.HeaderLink, { isRounded: true, "aria-label": _js('Manage'), href: "/Manage", className: "header-link__manage", "data-feature-id": "header_link_manage" },
            React.createElement(Icon_1.Icon, { type: pro_regular_svg_icons_1.faCog, boxSize: 6 }))));
};
exports.ManageButton = ManageButton;
